import React, { useState, useRef,useEffect } from "react";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";

const SubmenuItem = ({ submenu, setShowsubmenus, setShowMenu }) => {
  const [showsubitems, setShowsubitems] = useState(false);
  const submenuRef = useRef();

  useEffect(() => {
    let handler = (e) => {
      if (submenuRef !== null) {
        if (!submenuRef.current.contains(e.target)) {
          setShowsubitems(false);
        }
      }
    };
    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  });


  return (
    <li className="relative" ref={submenuRef} >
      
      {submenu?.subitems ? (
        <div onClick={(e) => {e.stopPropagation(); setShowsubitems(!showsubitems)}} className="px-[15px] py-[8px] text-[#333] flex items-center justify-between gap-2 text-[12px] hover:bg-slate-100">
          <div className="flex items-center gap-2">
            {submenu.icon}
            <span>{submenu?.label}</span>
          </div>
          {submenu?.subitems && <MdKeyboardArrowRight />}
        </div>
      ) : (
        <Link
          to={submenu?.path}
          onClick={()=>{setShowMenu(false);setShowsubmenus(false);}}
          className="px-[15px] py-[8px] text-[#333] flex items-center justify-between gap-2 text-[12px] hover:bg-slate-100"
        >
          <div className="flex items-center gap-2">
            {submenu.icon}
            <span>{submenu?.label}</span>
          </div>
          {submenu?.subitems && <MdKeyboardArrowRight />}
        </Link>
      )}

      {showsubitems && submenu?.subitems && (
        <ul className="absolute z-10 top-0 right-0 left-[180px] bg-white py-[7px] min-w-[180px] border border-[#ddd] text-left text-[12px]">
          {submenu?.subitems?.map((subitem, index) => (
            <li
              key={index}
              className="px-[15px] py-[5px] text-[#333] flex items-center justify-between gap-2 hover:bg-slate-100"
              onClick={()=> {
                setShowsubitems(false);
                setShowsubmenus(false);
                setShowMenu(false)
              }}
            >
              <Link to={subitem?.path}>{subitem?.label}</Link>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

export default SubmenuItem;
